const metadataSlice = {
    navButtons: {
        builder: true,
        preset: false
    }
}

export default metadataSlice
export { metadataSlice }



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastSMBPremarket/config/components/selection/MetadataSlice/index.js